module.exports = __webpack_public_path__ + "img/eh.4d3df256.svg";